import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBarWrapper } from './styles';

const Progress = ({ value, style }) => (
  <ProgressBarWrapper value={value} style={style}>
    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
    <div role="progressbar" aria-valuenow={value} aria-valuemin="0" aria-valuemax="100" />
  </ProgressBarWrapper>
);

Progress.propTypes = {
  value: PropTypes.number,
  style: PropTypes.object,
};

export default Progress;
